module.exports = __webpack_public_path__ + "img/tj.5ba4e436.svg";